import { optionTitle_reply } from './ReplyOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ReplyOption: LazyOption = createLazyOption(
    {
        key: 'reply',
        titleStringKey: optionTitle_reply,
        searchTermsStringKey: optionTitle_reply,
    },
    lazyFullModule,
    m => m.default
);
export default ReplyOption;
